import * as React from 'react';
import { useSearch } from './useSearch';
import { PiralSearchInput } from './components';
export const SearchInput = () => {
    const [value, setValue] = useSearch();
    return React.createElement(PiralSearchInput, { setValue: setValue, value: value });
};
//# sourceMappingURL=SearchInput.js.map